import React, { useContext } from 'react';

import proptypes from 'prop-types';
const { bool } = proptypes;

import { ToolContext } from '../../context/tool-context';

import './loading.scss';

export const LoadingPriceBar = ({ isDeliveryFlow }) => {
  const tool = useContext(ToolContext);
  const isAVehicle = tool.isAVehicle();

  const loadingBlock = () => {
    return (
      <>
        <div className="blankedout">
          <div className="loading-price-rate">
            <div className="loading-main-price" />
            <div className="loading-main-labels">
              <div className="loading-main-label" />
            </div>
          </div>
        </div>
        <div className="price-block-bar" />
      </>
    );
  };

  return (
    <div className="loading-price-block">
      {loadingBlock()}
      {loadingBlock()}
      {loadingBlock()}
      {!isAVehicle && !isDeliveryFlow && loadingBlock()}
    </div>
  );

};

LoadingPriceBar.propTypes = {
  isDeliveryFlow: bool
};

LoadingPriceBar.defaultProps = {
  isDeliveryFlow: false
};

LoadingPriceBar.displayName = 'PriceBlock';